module.exports = __webpack_public_path__ + "static/media/L-5.b69c818b.svg";